var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24DollarSymbol = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    d: "M14.225 11.268c-.628-.347-1.295-.611-1.956-.886-.383-.158-.75-.343-1.074-.6-.638-.51-.516-1.336.231-1.663.212-.093.433-.122.658-.136.866-.046 1.688.113 2.472.49.39.188.518.128.65-.278.14-.43.255-.866.384-1.299.086-.29-.02-.482-.294-.604-.502-.222-1.018-.38-1.56-.466-.707-.11-.707-.113-.71-.823C13.022 4 13.022 4 12.018 4c-.146 0-.291-.003-.437 0-.469.014-.548.096-.561.569-.007.211 0 .423-.004.638-.003.627-.006.618-.608.836-1.454.528-2.352 1.52-2.448 3.106-.086 1.404.647 2.353 1.8 3.043.711.427 1.498.678 2.251 1.012.294.129.575.277.82.482.723.598.591 1.593-.268 1.97-.46.201-.945.25-1.444.188-.77-.096-1.507-.298-2.2-.658-.407-.211-.526-.155-.665.285-.12.38-.225.763-.33 1.146-.143.516-.09.638.403.88.627.303 1.298.458 1.982.568.536.085.552.109.559.664.003.25.003.505.006.756.004.318.156.503.483.51.37.006.743.006 1.113-.004.304-.007.46-.172.46-.48 0-.343.016-.69.003-1.033-.017-.35.136-.53.473-.622.776-.211 1.437-.627 1.946-1.249 1.414-1.718.876-4.233-1.127-5.34z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24DollarSymbol, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon _ 24_ dollar-symbol.6fee63fa.svg";
export { ForwardRef as ReactComponent };